import React, { useState } from 'react'
import PropTypes from 'prop-types'; 
import TopBar from '../Components/TopBar';

import '../Style/DashboardProfileSubmission.css';
import profile from "../Images/profile.svg";
import dashboard from '../Images/Dashboard.svg';
import submission from '../Images/submission.svg';
import logo from '../Images/logo-white.png'
import { Link , useLocation, useNavigate} from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux'
import {  } from "../Store/Actions/Auth";
import '../Style/AuthLayout.css'
import { Container, Spinner } from 'react-bootstrap';

import { logout } from '../Store/Actions/Auth'
import Toast from '../Helpers/Toast';

const AuthLayout = ({children}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector(state => state.auth)

  const { pathname } = useLocation()

  const [loading, setLoading] = useState(false);
  const [menu, setMenu] = useState(false);

  const toggleMenu = () => {
    setMenu(prevState => ! prevState)
  }

  const handleLogout = async () => {
    setLoading(true);
    dispatch(logout())
    .then((res) => {
        setLoading(false);
        if(res.status){

          Toast.fire({
            icon: 'success',
            title: 'Logout successful.'
          })
          setTimeout(() => {
            
            return navigate('/login');

          }, 1000)
        }
      }).catch(() => {
        setLoading(false);
      });

  }
  

  return (
  	<div className='main '>
      { loading ? <>
          <div className='loadingState d-flex align-items-center justify-content-center'>
            <Spinner animation='border' />
          </div>
        </> : ''}

        <header className="py-2 navbar  sticky-top bg-teal flex-md-nowrap p-0 shadow">
          <div className="navbar-brand col-md-3 col-lg-2 me-0 px-3 mx-2 fs-6">
              <Link to="/">
                <img alt="logo" src={logo} className="img-profile-logo" />
              </Link>
          </div>
          <div className="">
            <ul className="nav d-flex align-items-center ">    
              <Link onClick={() => setMenu(false)} to='/dashboard' 
                className={`navbar_nav-link py-2 ${pathname === '/dashboard' ? 'active_nav-link ' : ''} `}>
                <div className='d-flex align-items-center '>
                  <img alt="logo" src={dashboard} className=''/>
                  <h6  className='m-0 mx-1 nav-link'>Dashboard</h6>
                </div>
              </Link>
              <Link onClick={() => setMenu(false)} to='/profile' 
                className={`navbar_nav-link py-2 mx-3 ${pathname === '/profile' ? 'active_nav-link ' : ''} `}>
                <div className='d-flex align-items-center  '>
                <img alt="logo" src={profile} className=''/>
                <h6 className='m-0 mx-1 nav-link'>Profile</h6>
                </div>
              </Link>
              <Link onClick={() => setMenu(false)} to='/submissions' 
                className={`navbar_nav-link py-2 
                    ${(pathname === '/submissions') ? 'active_nav-link ' : ''} 
                  `}>
                <div className='d-flex align-items-center '>
                <img alt="logo" src={submission} className=''/>
                <h6  className='m-0 mx-1 nav-link'>Submissions</h6>
                </div>
              </Link>
             </ul>
          </div>
          <div className="navbar-nav mx-4">
            <div className="text-nowrap">
              <div className="position-relative d-flex align-items-center">
                <div className='d-flex align-items-center mx-3 py-2 py-lg-0 mx-lg-0'>
                  <span className='activeIcon'></span>
                  <span className='mx-4 text-white'>{ user?.name }</span>
                  <i onClick={() => toggleMenu()}   className="bi bi-chevron-down text-white"></i> 
                </div>


                {menu && <>
           
                  <div className='py-1  position-absolute arrow-details ' style={{right:"0.2rem",top:"3rem", }}>
                    <div className=''>
                      <Link onClick={()=> setMenu(false)} className={'text-dark mb-2 text-lg link'} to="/dashboard"><h5 className={`text-lg py-2  px-3 border-bottom ${pathname === '/dashboard' ? 'text-pri' : ''}`}>Dashboard</h5></Link>
                      <Link onClick={()=> setMenu(false)} className={'text-dark mb-2 text-lg link'} to="/profile"><h5 className={`text-lg py-2  px-3 border-bottom ${pathname === '/profile' ? 'text-pri' : ''}`}>Profile</h5></Link>
                      <Link onClick={()=> setMenu(false)} className={'text-dark mb-2 text-lg link'} to="/submissions"><h5 className={`text-lg py-2  px-3 border-bottom ${pathname === '/submissions' ? 'text-pri' : ''}`}>Submissions</h5></Link>
                      <h5 
                        onClick={handleLogout} className='pt-1 pointer text-lg link'><h5 className={`text-lg py-2  px-3 border-bottom ${pathname === '/' ? 'text-pri' : ''}`}>Logout</h5></h5>
                    </div>
                  </div>
                 </> }
              </div>
            </div>
          </div>
        </header>
        <div className="content-wrapper container-fluid bg-teal ">
            <div className="row ">
             

              <main className="col-12  bg-white px-md-4">
                         
                {children}

              </main>
            </div>
          </div>
        
    </div>
    
  );
}

AuthLayout.propTypes = {   
  children: PropTypes.element.isRequired, 
};

export default AuthLayout;
